import {
  ADD_TO_CART,
  CLEAR_CART,
  COUNT_CART_TOTALS,
  REMOVE_CART_ITEM,
  TOGGLE_CART_ITEM_AMOUNT,
  SET_DETAILED_CART,
  SET_MAIN_COLOR,
  APPLY_COUPON,
} from '../actions';
import { toast } from 'react-toastify';

const cart_reducer = (state, action) => {
  if (action.type === ADD_TO_CART) {
    const {
      id,
      size,
      amount,
      product,
    } = action.payload;
    const tempItem = state.cart.find((item) => item.id === id);
    if (tempItem) {
      const tempCart = state.cart.map((cartItem) => {
        if (cartItem.id === id) {
          let newAmount = cartItem.amount + amount;
          if (newAmount > cartItem.max) {
            newAmount = cartItem.max;
          }
          return { ...cartItem, amount: newAmount };
        } else {
          return cartItem;
        }
      });
      return { ...state, cart: tempCart };
    } else {
      const newItem = {
        id: id,
        name: product.name,
        size,
      
        amount,
        image: product.productImageUrl,
        price: product.price,
        shipping: product.shipping,
        max: product.quantity,
        taxPrice:product.taxPrice,
       
        productWeight:product.productWeight,
        bestOffers:product.bestOffers,
        code:product.productCode
      };
      return { ...state, cart: [...state.cart, newItem] };
    }
  }

  if (action.type === SET_DETAILED_CART) {
    return {
      ...state,
      cart: action.payload,
    };
  }

  if (action.type === SET_MAIN_COLOR) {
    return { ...state, mainColor: action.payload };
  }
  

  if (action.type === REMOVE_CART_ITEM) {
    const tempCart = state.cart.filter((item) => item.id !== action.payload);
    return { ...state, cart: tempCart };
  }

  if (action.type === CLEAR_CART) {
    return { ...state, cart: [] };
  }

  if (action.type === TOGGLE_CART_ITEM_AMOUNT) {
    const { id, value } = action.payload;
    const tempCart = state.cart.map((item) => {
      if (item.id === id) {
        //increase
        if (value === 'inc') {
          let newAmount = item.amount + 1;
          if (newAmount > item.max) {
            newAmount = item.max;
          toast.error(`Only ${newAmount} products available`);

          }
          return { ...item, amount: newAmount };
        }
        //decrease
        if (value === 'dec') {
          let newAmount = item.amount - 1;
          if (newAmount < 1) {
            newAmount = 1;
          }
          return { ...item, amount: newAmount };
        }
      }
      return item;
    });
    return { ...state, cart: tempCart };
  }

if (action.type === COUNT_CART_TOTALS) {
  const { total_items, total_amount, shipping_fee, total_tax } = state.cart.reduce(
    (total, cartItem) => {
      const { price, amount, shipping, bestOffers, taxPrice } = cartItem;

      total.total_items += amount;

      let itemTotal = 0;

      if (bestOffers && amount >= Number(bestOffers.quantity)) {
        const offerQty = Number(bestOffers.quantity);
        const offerPrice = Number(bestOffers.offerPrice);

        const quotient = Math.floor(amount / offerQty);
        const remainder = amount % offerQty;

        if (bestOffers.type === 'Number') {
          itemTotal = ((quotient * (offerPrice)) + remainder * price)
          // +(amount*taxPrice*100)
          
        } else if (bestOffers.type === 'Percentage') {
        
          const discount = (price * offerPrice) / 100; 
          const discountedPrice = price - discount;
          itemTotal =
            quotient * offerQty * discountedPrice +
            remainder * price 
            // +
            // (amount * taxPrice*100);
        }
      } else {
        itemTotal = (price * amount)
        // +(amount*taxPrice*100);
      }

      total.total_amount += itemTotal;

      if (shipping) {
        total.shipping_fee = 0;
      }

      return total;
    },
    {
      total_items: 0,
      total_amount: 0,
      shipping_fee: 0,
      total_tax:0
    }
  );
  return {
    ...state,
    total_items,
    total_amount,
    shipping_fee,
    // total_tax: (total_amount / 95) * 5,
  };
}


  if (action.type === APPLY_COUPON) {
    return { ...state, couponDiscount: action.payload };
  }

  throw new Error(`No Matching "${action.type}" - action type`);
};

export default cart_reducer;
